import useSWR from 'swr'

import { AiVariationContext, AiVariationsTokenApiReply, HideModalCallback } from '../../aiVariationTypes'
import { doHttp, getApiUrl } from '../../util'

export const useManageAiVariationsTokenModal = (props: AiVariationContext & HideModalCallback) => {
	const changeOrCreateToken = async () =>
		(await doHttp<AiVariationsTokenApiReply>('POST', getApiUrl(props, null, true))).data[0].token

	const fetcher = async (key: string): Promise<string> => {
		try {
			const existingToken = await doHttp<AiVariationsTokenApiReply>('GET', key)
			if (existingToken?.status === 'OK' && existingToken.data.length > 0) {
				return existingToken.data[0].token
			}
		} catch (e) {
			// failed parsing json, so we'll just create a new token
		}

		return await changeOrCreateToken()
	}
	const { data, mutate } = useSWR<string>(getApiUrl(props, null, true), fetcher)

	const changeApprovalUrl = async () => {
		mutate(await changeOrCreateToken())
	}

	return {
		approvalUrl: data ? `${location.origin}/external/ad_approval/${data}` : '',
		changeApprovalUrl,
	}
}
